import { render, staticRenderFns } from "./ResultsComponent.vue?vue&type=template&id=6762cae2&scoped=true&"
import script from "./ResultsComponent.vue?vue&type=script&lang=js&"
export * from "./ResultsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6762cae2",
  null
  
)

export default component.exports